import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import { generateCalendarEventTypeTestId } from "../../utils/general";
import { PATIENT_CANCELLATION_TYPES, patientStatusType } from "../../utils/event";

import {
  CalendarEventBadge,
  CalendarEventBody,
  CalendarEventTime,
  CalendarEventTitle,
} from "./CalendarEvent";
import "./styles.scss";

const PatientSession = ({
  availability,
  details,
  endTime,
  patientName,
  patientPreferredName,
  position,
  startTime,
  status,
}) => {
  const cancelledClass =
    status?.text === PATIENT_CANCELLATION_TYPES.patientNoShow.text ? "no-show" : "cancelled";

  return (
    <CalendarEventBody
      className={
        status?.isCancelled ? `PatientSession-${cancelledClass}__body` : "PatientSession__body"
      }
      // passing in ad hoc availability if any allows it to be displayed in the
      // appointment side drawer when selected so available slots are not completely hidden
      details={[details, ...availability]}
      hasBadge={status?.isCancelled}
      position={position}
      testId={`PatientSession_${startTime?.format("YYYY-MM-DD_HHmm")}_${endTime?.format(
        "YYYY-MM-DD_HHmm",
      )}`}
    >
      <CalendarEventTitle
        className={
          status?.isCancelled ? `PatientSession-${cancelledClass}__title` : "PatientSession__title"
        }
        data-private
        testId={generateCalendarEventTypeTestId(status)}
        title={`${patientName} ${patientPreferredName ? `(${patientPreferredName})` : ""}`}
      />

      {/* if the status is cancelled display a banner partially over top of the current time */}
      {status?.isCancelled && (
        <CalendarEventBadge
          className={`PatientSession-${cancelledClass}__badge`}
          text={status.text}
        />
      )}

      <CalendarEventTime
        className={status?.isCancelled && "CalendarEvent__time-with-badge"}
        endTime={endTime}
        startTime={startTime}
        strikeTimes={status?.isCancelled}
      />
    </CalendarEventBody>
  );
};

PatientSession.propTypes = {
  availability: PropTypes.arrayOf(PropTypes.object),
  details: PropTypes.object,
  endTime: PropTypes.instanceOf(moment),
  patientName: PropTypes.string,
  patientPreferredName: PropTypes.string,
  position: PropTypes.object,
  startTime: PropTypes.instanceOf(moment),
  status: patientStatusType,
};

export { PatientSession };
